module.exports = __webpack_public_path__ + "img/img55.f374b762.jpg";